import { Container } from '@mui/material';
import React from 'react';

const NotFound = () => {
  return (
    <Container
      maxWidth="xl"
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '80vh',
        width: '500px',
        textAlign: 'center',
      }}
    >
      404
    </Container>
  );
};

export default NotFound;
